import { useAuth } from '../contexts/AuthContext';
import { isEffectivelyStorageLinked, requiresExternalStorage } from '../utils/storageNavigation';

export function useStorageGate() {
  const {
    driveLinked,
    usingCassetteCloud,
    storageProvider,
    migrationStatus,
    isAnonymous,
    userType,
    includesCassetteCloud,
    s3Ready,
  } = useAuth();
  const migrating = migrationStatus === 'in_progress';
  const storageDeclined = storageProvider === 'none';
  const navigationState = {
    userType,
    includesCassetteCloud,
    driveLinked,
    storageProvider,
    isAnonymous,
  };
  const effectivelyLinked = isEffectivelyStorageLinked(navigationState);
  const cassetteCloudUnavailable = storageProvider === 'cassette_s3' && s3Ready === false;
  const storageReady = effectivelyLinked && !cassetteCloudUnavailable;
  const needsExternalDrive = requiresExternalStorage(navigationState);

  return {
    canMutate: storageReady && !migrating,
    canUpload: storageReady && !migrating,
    canShare: storageReady && !migrating,
    canCreate: storageReady && !migrating,
    requiresAccount: isAnonymous,
    showBanner: (!storageReady || cassetteCloudUnavailable) && !storageDeclined,
    showMigrationBanner: migrating,
    storageLinked: storageReady,
    usingCassetteCloud,
    needsExternalDrive,
    migrationStatus,
    s3Ready,
    cassetteCloudUnavailable,
  };
}
